const { createAction } = require('@reduxjs/toolkit');

export const logOut = createAction('app/logOut');
